// Types
import { OrderErrorTableReport } from "src/Interfaces/orderInterfaces";
import { ISearchParameters, Report } from "src/Interfaces/TableInterfaces";
// Common Components
import TableTemplate from "src/Tables/TableTemplate/tableTemplate";
import { CommonTableUI } from "src/Tables/TableTemplate/common";

interface IErrorsTableProps<T> {
  getData: (
    searchParameters: T,
    offset: number | null,
    pageSize: number | null
  ) => Promise<Report<OrderErrorTableReport>>;
  searchParams: T;
  onFetchComplete: (page?: number) => void;
  refreshTableTime?: number;
  refreshFlag?: boolean;
}

const ErrorsTable = <T extends ISearchParameters>({
  getData,
  searchParams,
  onFetchComplete,
  refreshTableTime,
  refreshFlag,
}: IErrorsTableProps<T>) => {
  return (
    <div className="order-table w-full">
      <TableTemplate<T, OrderErrorTableReport>
        getDataTable={getData}
        searchParameters={searchParams}
        TableUI={({ reports, onAction }) => (
          <CommonTableUI
            reports={reports}
            onAction={onAction}
            tableBoxClassName={`max-h-[500px] overflow-auto !max-h-[300px]`}
            refreshFlag={refreshFlag}
          />
        )}
        onFetchComplete={onFetchComplete}
        refreshTableTime={refreshTableTime}
      />
    </div>
  );
};

export default ErrorsTable;
